import pug from 'javascripts/core_post_webpack/sitewide_business_elements/modals/templates/confirm_modal.jst.pug';
window.JST = window.JST || {};
window.JST[
  'core_post_webpack/sitewide_business_elements/modals/templates/confirm_modal'
] = pug;
